module.exports = __webpack_public_path__ + "static/media/보상 및 혜택.b5e42b01.png";